import { Component } from '@angular/core';

@Component({
  selector: 'taly-without-taly',
  templateUrl: './without-taly.component.html',
  styleUrls: ['./without-taly.component.scss'],
  standalone: false,
})
export class WithoutTalyComponent {}
